// extracted by mini-css-extract-plugin
export default {"returnButton":"NotFoundPage_returnButton__WmV6a"};